export class ManagerFilter {

    [key: string]: string | string[];

    teamName:string[]
    year:string;
    employeeYear:string;

    constructor() {
        this.year='';
        this.teamName=[];
        this.employeeYear='';

    }
}